<template>
    <DsDropdown
        data-qa="header-stealth-menu"
        disable-scroll
        :is-open="isOpen"
        position="bottom-end"
        @close="close"
    >
        <template #default>
            <DsTextButton
                data-qa="expand-menu"
                trailing-icon="chevron-down"
                :disabled="disabled"
                @click="toggle"
            >
                <div>
                    {{ $t('funnel.edit.debug') }}
                </div>
            </DsTextButton>
        </template>

        <template #menu>
            <ul class="dropdown-menu-list">
                <li
                    data-qa="export-button"
                    class="dropdown-menu-item"
                    @click="onExport"
                >
                    {{ $t('funnel.edit.debug.export') }}
                </li>

                <li
                    data-qa="import-button"
                    class="dropdown-menu-item"
                    @click="onImport"
                >
                    {{ $t('funnel.edit.debug.import') }}
                </li>

                <li
                    data-qa="reset-button"
                    class="dropdown-menu-item"
                    @click="onReset"
                >
                    {{ $t('funnel.edit.debug.reset') }}
                </li>
            </ul>
        </template>
    </DsDropdown>
</template>

<script>
import { CONSTANTS_STEALTH_MENU } from '../utils/editor.constants';

export default {
    CONSTANTS_STEALTH_MENU,

    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click-export', 'click-import', 'click-reset'],
    data() {
        return {
            isOpen: false,
        };
    },

    methods: {
        onExport() {
            this.$emit('click-export');
            this.close();
        },

        onImport() {
            this.$emit('click-import');
            this.close();
        },

        onReset() {
            this.$emit('click-reset');
            this.close();
        },

        toggle() {
            this.isOpen = !this.isOpen;
        },

        close() {
            this.isOpen = false;
        },
    },
};
</script>
<style scoped lang="scss">
#stealth-dropdown .button > div {
    margin-right: 0;
}

#stealth-dropdown .dropdown-menu-item {
    font-size: 13px;
    color: #444;
    white-space: normal;
    text-align: left;
    line-height: normal;
    padding: 0.5rem 1rem;
    width: 250px;
}

.dropdown-menu .menu {
    height: auto;
}
#stealth-dropdown .button {
    color: #0040DB;
}
</style>
